import _Vue from 'vue';
import ToolkitModelRoot from './ToolkitModelRoot';

export function ToolkitModelRootPlugin(Vue: typeof _Vue, model: ToolkitModelRoot): void {
  Vue.prototype.$toolkitModel = model;
}
